module.exports = __webpack_public_path__ + "static/img/indexLogo.173780e0.png";